import React from 'react';
import type { Candidate } from '@axiom/validation';
import { Gutter, Icon, Layout, SectionHeader } from '@axiom/ui';

export type ProfileHeaderBarAdmissionsProps = {
  candidate: Candidate;
};

export const ProfileHeaderBarAdmissions = ({
  candidate,
}: ProfileHeaderBarAdmissionsProps) => {
  if (!candidate.barredLocations || candidate.barredLocations.length === 0) {
    return null;
  }

  return (
    <div data-test="BAR_ADMISSIONS_SECTION">
      <SectionHeader>Bar Admissions</SectionHeader>
      <Gutter bottom="16px" />
      <Layout
        horizontalGutter="24px"
        verticalGutter="8px"
        wrap
        name="BAR_ADMISSIONS"
      >
        {candidate.barredLocations.map(bl => (
          <Layout
            horizontalGutter="8px"
            key={bl.name}
            position="middle"
            inline
            name="BAR_ADMISSION"
          >
            <Icon name="waypoint-filled" />

            <span>{bl.name}</span>
          </Layout>
        ))}
      </Layout>
      <Gutter bottom="16px" only="smallScreen" />
    </div>
  );
};
